const mcuBookingRoutes = [
    {
        path: '/mcu-booking',
        name: 'mcuBookings',
        children: [
            {
                path: '',
                name: 'mcuBookingList',
                component: () => import('@/modules/mcu_booking/list/List.vue'),
                meta: {
                    resource: 'bookings',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Booking Management',
                    breadcrumbs: [{ title: 'Booking Management', routeName: 'mcuBookingList' }]
                }
            }
        ]
    }
]

export default mcuBookingRoutes
